import { render, staticRenderFns } from "./GreetingsEditor.vue?vue&type=template&id=9d7c427e&scoped=true&"
import script from "./GreetingsEditor.vue?vue&type=script&lang=js&"
export * from "./GreetingsEditor.vue?vue&type=script&lang=js&"
import style0 from "./GreetingsEditor.vue?vue&type=style&index=0&id=9d7c427e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7c427e",
  null
  
)

export default component.exports